<template>
  <div class="pt-2">
    <v-card flat>
      <v-form v-model="valid">
        <v-row no-gutters align="center" justify="space-around">
          <v-col cols="12" sm="1" style="text-align: right">
            <label>巡检项编号:</label>
          </v-col>
          <v-col cols="12" sm="3">
            <v-text-field
                class="form-item-value"
                v-model="filter.id"
                label=""
                outlined
                dense
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="1" style="text-align: right">
            <label>巡检项名称：</label>
          </v-col>
          <v-col cols="12" sm="3">
            <v-text-field
                class="form-item-value"
                v-model="filter.itemName"
                label=""
                outlined
                dense
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="1"></v-col>
          <v-col cols="12" sm="2">
            <v-btn color="primary" class="mr-2" depressed @click="handleSearch" v-if="_hasButtonPermission('查询')"
            >查询
            </v-btn
            >
            <v-btn depressed @click="handleResetSearch" v-if="_hasButtonPermission('查询')">重置</v-btn>
            <v-btn depressed @click="back()" v-if="_hasButtonPermission('返回')">返回</v-btn>
          </v-col>
        </v-row>
      </v-form>
      <v-data-table
          ref="data"
          :headers="headers"
          fixed-header
          :items="desserts"
          class="elevation-1 mt-2"
          :loading="loading"
          :server-items-length="totalDesserts"
          :page.sync="filter.pageNum"
          :items-per-page.sync="filter.pageSize"
          @update:page="handlePageChanged"
          @update:items-per-page="handlePageSizeChanged"
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-btn color="primary" depressed class="mr-2" @click="doInsert" v-if="_hasButtonPermission('新增')">
              添加巡检项
            </v-btn>
          </v-toolbar>
        </template>
        <template v-slot:[`item.status`]="{ item }">
          {{ item.status === 2 ? "禁用" : "启用" }}
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-btn text color="primary" small :disabled="!(_hasButtonPermission('修改'))"
                 @click="editItem(item)">修改
          </v-btn>

          <v-btn text color="primary" small :disabled="!(_hasButtonPermission('启用'))"
                 @click="item.status = item.status ==2?1:2;updateItem(item);getDataFromApi()"
          >{{ item.status == 2 ? '启用' : '停用' }}
          </v-btn>
        </template>
      </v-data-table>
      <!--新增弹窗-->
      <v-dialog v-model="insert.dialog" width="600">
        <v-card>
          <v-card-title class="text-h5 grey lighten-2"
          >新增巡检项
          </v-card-title
          >
          <v-card-text>
            <v-container>
              <v-row>
                <v-col>
                  <v-text-field label="巡检项名称" v-model="insert.item.itemName"></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn color="primary" text @click="insertItem"> 保存</v-btn>
            <v-btn text @click="insert.dialog = false"> 取消</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!--修改弹窗-->
      <v-dialog v-model="edit.dialog" width="600">
        <v-card>
          <v-card-title class="text-h5 grey lighten-2"
          >修改巡检项
          </v-card-title
          >
          <v-card-text>
            <v-container>
              <v-row>
                <v-col>
                  <v-text-field label="巡检项编号" disabled v-model="edit.item.id"></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-text-field label="巡检项名称" v-model="edit.item.itemName"></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn color="primary" text @click="saveItem"> 保存</v-btn>
            <v-btn text @click="edit.dialog = false"> 取消</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>
  </div>
</template>

<script>
import PdXjPointItemApi from "@/api/pd/xj/PdXjPointItemApi.js";
import {default as PermissionApi} from "@/api/smp/auth/Permission";

export default {
  itemName: "Pd-Xj-Point-Item-Edition",
  props: {
    id: [Number, String],
    page: {
      type: Object,
      default: null,
    }
  },
  data() {
    return {
      tab: null,
      buttonPriviledgeList: [],
      pointId: null,
      filter: {
        id: "",
        itemName: "",
        pointId: null,
        pageNum: 1,
        pageSize: 15,
      },
      headers: [
        {
          text: "巡检项编号",
          value: "id",
          sortable: false,
          width: 65,
          divider: true,
          groupable: false
        },
        {
          text: "巡检项名称",
          value: "itemName",
          sortable: false,
          width: 100,
          divider: true,
        },
        {
          text: "状态",
          align: "start",
          sortable: false,
          value: "status",
          width: 80,
          divider: true,
          groupable: false
        },
        {
          text: "最后修改人",
          align: "start",
          sortable: false,
          value: "updateBy",
          width: 80,
          divider: true,
          groupable: false
        },
        {
          text: "最后修改时间",
          align: "start",
          sortable: false,
          value: "updateTime",
          width: 150,
          divider: true,
          groupable: false
        },
        {
          text: "操作",
          align: "start",
          sortable: false,
          value: "actions",
          width: 150,
          divider: true,
          groupable: false
        },
      ],
      desserts: [],
      loading: false,
      totalDesserts: 0,
      valid: false,
      edit: {
        item: {},
        dialog: false,
      },
      insert: {
        item: {
          itemName: null,
          pointId: null,
          status: 1
        },
        dialog: false,
      }
    };
  },
  mounted() {
    this.filter.pointId = this.id;
    this.getButtonPriviledge();
    this.getDataFromApi();
  },
  methods: {
    handleSearch() {
      this.getDataFromApi();
    },
    handleResetSearch() {
      this.filter = {
        id: null,
        itemName: null,
        pointId: this.id,
        pageNum: 1,
        pageSize: 15,
      };
      this.getDataFromApi();
    },
    handlePageChanged(pageNum) {
      this.filter.pageNum = pageNum;
      this.getDataFromApi();
    },
    handlePageSizeChanged(pageSize) {
      if (pageSize == -1) {
        pageSize = 100;
      }
      this.filter.pageNum = 1;
      this.filter.pageSize = pageSize;
      this.getDataFromApi();
    },
    getDataFromApi() {
      this.loading = true;
      this.desserts = [];
      let me = this;

      PdXjPointItemApi.get(this.filter)
          .then((resp) => {
            PdXjPointItemApi.handleResponse(
                resp,
                me,
                function (data) {
                  me.loading = false;
                  me.desserts = data.rows;
                  me.totalDesserts = data.total;
                },
                function () {
                  me.loading = false;
                }
            );
          })
          .catch((error) => {
            PdXjPointItemApi.handleNetworkError(error, me, function () {
              me.loading = false;
            });
          });
    },
    doInsert() {
      this.insert.item.pointId = this.filter.pointId;
      this.insert.dialog = true;
    },
    getButtonPriviledge() {
      // console.log('this.page',this.page)
      // let menuId = this.page.id
      // let me = this
      // PermissionApi.queryButtonPriviledge(menuId,null).then(resp=>{
      //   PermissionApi.handleResponse(resp, me, function (data){
      //     me.buttonPriviledgeList = data.buttonPriviledges
      //     console.log('buttonPriviledgeList',me.buttonPriviledgeList)
      //   })
      // })
    },
    _hasButtonPermission(itemName) {
      // let buttonPriviledgeList = this.buttonPriviledgeList;
      // let hasButton = false;
      // for (let i = 0; i < buttonPriviledgeList.length; i++) {
      //   if (buttonPriviledgeList[i].itemName == itemName) {
      //     if (buttonPriviledgeList[i].hasPriviledge == "Y") {
      //       return true;
      //     } else {
      //       return false;
      //     }
      //   }
      // }
      // return false;
      return true;
    },
    // jump() {
    //   this.$router.push({path: '/pd/maintenance/xj-point', query: {}});
    // },
    back(){
      this.$emit("back")
    },
    async updateItem(item) {
      let me = this;
      let confirm = await me.$dialog.confirm({
        text: item.status == 1 ? "确认停用巡检项吗？" : "确认启用巡检项吗？",
        title: "提示",
      });
      if (confirm) {
        let res = await PdXjPointItemApi.update(item);
        if (res.status === 200) {
          me.$dialog.info({
            text: res.msg,
            title: "操作成功",
          });
          me.getDataFromApi();
        } else {
          me.$dialog.error({
            text: res.msg,
            title: "操作成功",
          });
          me.getDataFromApi();
        }
      }
    },
    async editItem(item) {
      this.edit.item = Object.assign({}, item);
      this.edit.dialog = true;
    },
    async saveItem() {
      let res = await PdXjPointItemApi.update(this.edit.item);
      if (res.status === 200) {
        this.$dialog.info({
          text: res.msg,
          title: "操作成功",
        });
        this.edit.dialog = false;
        this.getDataFromApi();
      } else {
        this.$dialog.error({
          text: res.msg + ':' + res.data.msg_detail,
          title: "操作失败",
        });
        this.edit.dialog = false;
        this.getDataFromApi();
      }
    },
    async insertItem() {
      let res = await PdXjPointItemApi.insert(this.insert.item);
      if (res.status === 200) {
        this.$dialog.info({
          text: res.msg,
          title: "操作成功",
        });
        this.insert.dialog = false;
        this.getDataFromApi();
      } else {
        this.$dialog.error({
          text: res.msg + ':' + res.data.msg_detail,
          title: "操作失败",
        });
        this.insert.dialog = false;
        this.getDataFromApi();
      }
    },
  },
};
</script>
<style scoped>
.padding-bottom {
  padding: 0 16px;
  /**padding-bottom: 12px;**/
}

.padding-top {
  padding-top: 30px;
}

.margin-right {
  margin-right: 12px;
}
</style>